/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: {
      value: 1,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: ""
    },
    title: {
      value: "Kết quả kinh doanh ghi nhận theo báo cáo tài chính",
    },
  },
  {
    id: {
      value: 2,
    },
    stt: "1",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[04]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập lãi và các khoảng thu nhập tương tự"
  },
  },
  {
    id: {
      value: 3,
    },
    stt: "2",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[05]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí lãi và các chi phí tương tự",
    },
  },
  {
    id: {
      value: 4,
    },
    stt: "3",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[06]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập lãi thuần ([06]=[04]-[05])",
    },
  },
  {
    id: {
      value: 5,
    },
    stt: "4",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[07]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập từ hoạt động dịch vụ",
    },
  },
  {
    id: {
      value: 6,
    },
    stt: "5",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[08]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí hoạt động dịch vụ",
    },
  },
  {
    id: {
      value: 7,
    },
    stt: "6",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[09]",
    value2: {
      value: 0
    },
    title: {
      value: "Lãi / lỗ thuần từ hoạt động dịch vụ ([09]=[07]-[08])",
    },
  },
  {
    id: {
      value: 8,
    },
    stt: "7",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[10]",
    value2: {
      value: 0
    },
    title: {
      value: "Lãi / lỗ thuần từ hoạt động kinh doanh ngoại hối",
    },
  },
  {
    id: {
      value: 9,
    },
    stt: "8",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[11]",
    value2: {
      value: 0
    },
    title: {
      value: "Lãi / lỗ thuần từ mua bán chứng khoán kinh doanh",
    },
  },
  {
    id: {
      value: 10,
    },
    stt: "9",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[12]",
    value2: {
      value: 0
    },
    title: {
      value: "Lãi / lỗ thuần từ mua bán chứng khoán đầu tư",
    },
  },
  {
    id: {
      value: 11,
    },
    stt: "10",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[13]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập từ hoạt động khác",
    },
  },
  {
    id: {
      value: 12,
    },
    stt: "11",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[14]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí hoạt động khác",
    },
  },
  {
    id: {
      value: 13,
    },
    stt: "12",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[15]",
    value2: {
      value: 0
    },
    title: {
      value: "Lãi / lỗ thuần từ hoạt động khác ([15]=[13]=[14])",
    },
  },
  {
    id: {
      value: 14,
    },
    stt: "13",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[16]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập từ góp vốn mua cổ phần",
    },
  },
  {
    id: {
      value: 15,
    },
    stt: "14",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[17]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí hoạt động",
    },
  },
  {
    id: {
      value: 16,
    },
    stt: "15",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[18]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí dự phòng rủi ro tín dụng",
    },
  },
  {
    id: {
      value: 17,
    },
    stt: "6",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[19]",
    value2: {
      value: 0
    },
    title: {
      value: "Tổng hợp lợi nhuận trước thuế ([19]=[06]+[09]+[10]+[11]+[12]+[15]+[16]-[17]-[18])",
    },
  },
];

export default function Table3({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
        <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (3)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (4)
              </Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.stt}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.title.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.value1}
                  </Td>

                  <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.bg ? "transparent" : "#ddeff3",
                          fontWeight: !row.bold ? "normal" : "bold",
                          fontStyle: !row.ilalic ? "normal" : "italic"
                        }}
                      >
                        {row.bg ? (
                          row.value2.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="value2"
                            value={row.value2.value}
                            onChange={handleChange}
                            isBold = {row.bold}
                          />
                        )}
                      </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, isBold, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: isBold ? "bold" : "normal"
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
